module.exports = __webpack_public_path__ + "img/poster_1.7364014f.jpg";